import calculateBonusValues from './calculateBonusValues';

export const sections = [
    { id: 'classes', key: 'classes', title: 'Classes' },
    { id: 'mentor-me', key: 'mentorMe', title: 'Mentor Me' },
    { id: 'test-series', key: 'testSeries', title: 'Test Series' },
];

export const unwrapBonusResponse = (response) => (
    response && Object.prototype.hasOwnProperty.call(response, 'data') ? response.data : response
);

const isCombinedBonuses = (data) => (
    data && sections.some(({ key }) => Object.prototype.hasOwnProperty.call(data, key))
);

const emptySection = ({ id, title }) => id === 'test-series' ? {
    title,
    subtitle: '',
    currency: 'INR',
    combinedValue: 0,
    benefits: [],
    availabilityNote: {},
    terms: [],
} : {
    title,
    subtitle: '',
    currency: 'INR',
    totalBonusValue: 0,
    bonuses: [],
    availability: {},
    includedAtNoAdditionalCost: false,
};

export const combineBonuses = (data) => {
    const combined = isCombinedBonuses(data) ? { ...data } : {
        mentorMe: data && Object.keys(data).length > 0 ? data : undefined,
    };

    sections.forEach((section) => {
        if (combined[section.key] == null) combined[section.key] = emptySection(section);
    });
    return combined;
};

export const prepareBonusesForSave = (data) => {
    const combined = combineBonuses(data);
    sections.forEach(({ id, key }) => {
        const itemsKey = id === 'test-series' ? 'benefits' : 'bonuses';
        const valueField = id === 'test-series' ? 'combinedValue' : 'totalBonusValue';
        if (Array.isArray(combined[key][itemsKey])) {
            combined[key] = calculateBonusValues(combined[key], itemsKey, valueField);
        }
    });
    return combined;
};
